import { useEffect, useState } from 'react'
import Celikler from '../../components/general/Celikler'
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from 'react-redux';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';
import Banner from '../../components/general/Banner';
import { useTranslation } from 'react-i18next';
import { URL } from '../../api';
import { Link } from 'react-router-dom';

const DownloadPage = () => {
    const page = useSelector((state) => state.pageGetSlug.data);
    const lang = useSelector((state) => state.lang.lang);
    const seo = useSelector((state) => state.seoGet.data);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const getData = async () => {
        setLoading(true)
        await dispatch(fetchPageGetSlug({ slug: "indirme" }));
        await dispatch(fetchSeoGet({ slug: "indirme" }));
        setLoading(false)
    }

    console.log(page)

    useEffect(() => { getData() }, [])

    return (
        !loading ? <Celikler>
            {seo && seo.title && seo.description && (
                <Helmet>
                    <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
                    <meta name="description" content={seo.description?.[lang] || ""} />
                    <meta name="keywords" content={seo.keywords?.[lang] || ""} />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
            )}
            <Banner title={page?.title[lang]} />

            <div className='container'>
                <div className='w-100 mt-2'><img src={`${URL}${page?.showcases[0]?.files[0]}`} alt='' className='w-100' /></div>
                <div className='mt-4'>
                    <div className='w-100 text-center'><h2><strong>{page?.showcases[1]?.title[lang]}</strong></h2></div>
                    <div className='mt-3' dangerouslySetInnerHTML={{ __html: page?.showcases[1]?.content[lang] }}></div>
                    <div className='mt-4 bottom-imgs'>
                        <div><Link target='_blank' to={page?.showcases[1]?.description.tr}><img src={`${URL}${page?.showcases[1]?.files[0]}`} alt='' className='h50' style={{ width: "148px", object: "cover", height: 50 }} /></Link></div>
                        <div className='mx-2'></div>
                        <div><Link target='_blank' to={page?.showcases[1]?.description.en}><img src={`${URL}${page?.showcases[1]?.files[1]}`} alt='' className='h50' style={{ width: "148px", object: "cover", height: 50 }} /></Link></div>
                    </div>
                </div>
            </div>

        </Celikler> : <div className="modern-spinner-wrapper">
            <div className="modern-spinner"></div>
        </div>
    )
}

export default DownloadPage
